export const mobileMaxWidth = 480;
export const tabletMaxWidth = 834;
